/* eslint-disable no-undef */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // Добавить импорт

const Analytics = () => {
  const location = useLocation(); 

  // Загрузка метрик (один раз при монтировании)
  useEffect(() => {
    const timer = setTimeout(() => {
      // ========== Яндекс Метрика ==========
      (function(m, e, t, r, i, k, a) {
        m[i] = m[i] || function() {
          (m[i].a = m[i].a || []).push(arguments);
        };
        m[i].l = 1 * new Date();
        for (var j = 0; j < document.scripts.length; j++) {
          if (document.scripts[j].src === r) return;
        }
        k = e.createElement(t);
        a = e.getElementsByTagName(t)[0];
        k.async = true;
        k.src = r;
        a.parentNode.insertBefore(k, a);
      })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js?id=108429251", "ym");

      ym(108429251, "init", {
        ssr: true,
        webvisor: true,
        clickmap: true,
        ecommerce: "dataLayer",
        referrer: document.referrer,
        url: window.location.href,
        accurateTrackBounce: true,
        trackLinks: true,
      });

      // ========== Google Analytics ==========
      const gtagScript = document.createElement('script');
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-SJ6QD8J24R';
      gtagScript.async = true;
      document.head.appendChild(gtagScript);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function() {
        window.dataLayer.push(arguments);
      };
      gtag('js', new Date());
      gtag('config', 'G-SJ6QD8J24R');
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  // Отслеживание переходов между страницами
  useEffect(() => {
    const sendPageView = () => {
      if (window.ym) {
        window.ym(108429251, "hit", location.pathname);
      }
      if (window.gtag) {
        window.gtag("config", "G-SJ6QD8J24R", {
          page_path: location.pathname,
        });
      }
    };

    const timer = setTimeout(sendPageView, 200);
    return () => clearTimeout(timer);
  }, [location.pathname]); 

  return null;
};

export default Analytics;